import type { NskResponse } from "~/models/Api";
import type { DealUploadFile } from "~/models/DealUploadFile";
import { deleteRequest } from "~/utils/api/api_handler";

const paths = {
	destroy: "/deals/:deal_id/deal_uploaded_files/:id",
	show: `${process.env.NEXT_PUBLIC_API_HOST}/api/deals/:deal_id/deal_uploaded_files/:id`
};

export const getFilePath = (dealId: number, file: DealUploadFile): string =>
	paths.show
		.replace(":deal_id", String(dealId))
		.replace(":id", String(file.id));

export const destroy = async (
	dealId: number,
	id: number
): Promise<NskResponse> =>
	deleteRequest(
		paths.destroy.replace(":deal_id", String(dealId)).replace(":id", String(id))
	);
